export default ({image, desc}) => {
    return (
        <div className="Testimonial">
            <img classname='Testimonial__image' src={image} height="222px" width="320px"/>
            <div className='Testimonial__text'><div className='Testimonial__quote'><span style={{marginTop: '0.3em'}}>“</span></div><span style={{margin: '0 1em'}}>{desc}</span></div>
        </div>
    );
}